var map = {
	"./en-US/dataTableMessages.ts": 80390,
	"./en-US/filterMessages.ts": 44621,
	"./en-US/forgotPasswordMessages.ts": 20765,
	"./en-US/globalMessages.ts": 28505,
	"./en-US/index.ts": 69979,
	"./en-US/loginMessages.ts": 54574,
	"./en-US/maintenanceUserMessages.ts": 75061,
	"./en-US/resetPasswordMessages.ts": 14005,
	"./en-US/userFormMessages.ts": 83862,
	"./en-US/yupMessages.ts": 88129,
	"./es/dataTableMessages.ts": 32594,
	"./es/filterMessages.ts": 11286,
	"./es/forgotPasswordMessages.ts": 86310,
	"./es/globalMessages.ts": 81264,
	"./es/index.ts": 54349,
	"./es/loginMessages.ts": 61536,
	"./es/maintenanceUserMessages.ts": 39355,
	"./es/resetPasswordMessages.ts": 1233,
	"./es/userFormMessages.ts": 86227,
	"./es/yupMessages.ts": 120,
	"./i18n.ts": 51535,
	"./interfaces/dataTableMessages.ts": 64084,
	"./interfaces/filterMessages.ts": 79373,
	"./interfaces/forgotPasswordMessages.ts": 93018,
	"./interfaces/globalMessages.ts": 44313,
	"./interfaces/index.ts": 65488,
	"./interfaces/loginMessages.ts": 1932,
	"./interfaces/maintenanceUserMessages.ts": 75096,
	"./interfaces/resetPasswordMessages.ts": 17939,
	"./interfaces/userFormMessages.ts": 84806,
	"./interfaces/yupMessages.ts": 30665,
	"./languageData.ts": 25827,
	"./pt-BR/dataTableMessages.ts": 73839,
	"./pt-BR/filterMessages.ts": 1007,
	"./pt-BR/forgotPasswordMessages.ts": 91195,
	"./pt-BR/globalMessages.ts": 1123,
	"./pt-BR/index.ts": 10923,
	"./pt-BR/loginMessages.ts": 63991,
	"./pt-BR/maintenanceUserMessages.ts": 47802,
	"./pt-BR/resetPasswordMessages.ts": 83828,
	"./pt-BR/userFormMessages.ts": 11520,
	"./pt-BR/yupMessages.ts": 62702,
	"./useTranslation.ts": 88636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73213;